import * as focusTrap from 'focus-trap';
import Overlay from '../overlay';
import { repaint } from '~/js/utils/node';

class Openable {
  constructor({
    element, zIndex = { element: 50, overlay: 40 }, overlay = true, overlayTriggersClose = true,
  }) {
    this.isActive = false;

    if (typeof element === 'string' || element instanceof String) {
      this.container = document.querySelector(element);
    } else {
      this.container = element;
    }

    this.container.hidden = true;
    this.setState(false);
    this.container.style.zIndex = zIndex.element;

    this.focusTrap = focusTrap.createFocusTrap(this.container, {
      allowOutsideClick: true,
    });

    this.clickEvent = this.clickEvent.bind(this);
    this.keydownEvent = this.keydownEvent.bind(this);
    this.addEventListeners = this.addEventListeners.bind(this);

    if (overlay) {
      this.overlay = new Overlay(zIndex.overlay);
      this.overlayElement = this.overlay.element;
    }

    this.overlayTriggersClose = overlayTriggersClose;
  }

  addEventListeners() {
    this.overlayElement?.addEventListener('touchstart', this.clickEvent);
    this.overlayElement?.addEventListener('click', this.clickEvent);
    this.container.addEventListener('click', this.clickEvent);
    document.addEventListener('keydown', this.keydownEvent);
    this.focusTrap.activate();
  }

  removeEventListeners() {
    this.overlayElement?.removeEventListener('touchstart', this.clickEvent);
    this.overlayElement?.removeEventListener('click', this.clickEvent);
    this.container.removeEventListener('click', this.clickEvent);
    document.removeEventListener('keydown', this.keydownEvent);
    this.focusTrap.deactivate();
  }

  clickEvent(event) {
    if (!this.container.contains(event.target)/* || event.target === this.container */) {
      if (event.target === this.overlay && this.overlayTriggersClose === false) {
        return;
      }

      event.stopPropagation();
      this.close();
    }
  }

  keydownEvent(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  setState(state) {
    this.isActive = state;
    this.container.setAttribute('aria-hidden', state ? 'false' : 'true');
  }

  toggle() {
    if (this.isActive) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.dispatchEvent('open');

    this.setState(true);
    this.container.hidden = false;
    repaint(this.container);

    this.container.classList.add(this.classes.active);
    this.overlay?.show();

    document.documentElement.style.overflow = 'hidden';

    setTimeout(() => {
      this.addEventListeners();
    }, 0);

    this.container.addEventListener('transitionend', () => {
      if (this.isActive) {
        this.dispatchEvent('opened');
      }
    }, { once: true });
  }

  close() {
    this.dispatchEvent('close');
    this.setState(false);

    this.container.classList.remove(this.classes.active);
    this.overlay?.hide();

    this.removeEventListeners();

    document.documentElement.style.overflow = '';

    this.container.addEventListener('transitionend', () => {
      if (!this.isActive) {
        this.container.hidden = true;
        this.dispatchEvent('closed');
      }
    }, { once: true });

    if (this.onClose) this.onClose();
  }

  dispatchEvent(type) {
    const event = new Event(type);
    this.container.dispatchEvent(event);
  }

  on(type, callback, options) {
    this.container.addEventListener(type, (event) => callback(event), options);
  }
}

export default Openable;
